import {
  Component, Output, EventEmitter, Input, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, OnChanges, SimpleChanges
} from '@angular/core';
import { Keys } from '../common';

export class PageEvent {
  currentPage: number;
  perPage: number;
  perPageOrCurrPageChanged: boolean;
}

@Component({
  selector: 'app-pagination',
  templateUrl: 'pagination.component.html',
  styleUrls: ['pagination.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PaginationComponent implements OnChanges {

  ngOnChanges(changes: SimpleChanges): void {
    this.findElements('a', this.currentPage);
  }

  @Input() goMessage: string = 'Go';
  @Input() searchMessage: string = 'Go to Page:';

  @Input()
  get perPage(): number { return this._perPage; }
  set perPage(value: number) {
    this._perPage = value;
    this.pages = this.getPages();
  }
  private _perPage: number = 10;

  @Input()
  get totalItems(): number { return this._totalItems; }
  set totalItems(value: number) {
    this._totalItems = value;
    this.pages = this.getPages();
  }
  private _totalItems: number = 0;

  @Input()
  get currentPage(): number { return this._currentPage; }
  set currentPage(value: number) {
    const _previous = this._currentPage;
    this._currentPage = (value > this.totalPages()) ? this.totalPages() : (value || 1);

    if (_previous === this._currentPage || typeof _previous === 'undefined') {
      return;
    }
    this.pages = this.getPages();
  }
  private _currentPage: number = 1;

  //@Input()
  //get pageSizeOptions(): number[] { return this._pageSizeOptions; }
  //set pageSizeOptions(value: number[]) {
  //  this._pageSizeOptions = (value || []).sort((a, b) => a - b);
  //}
  //private _pageSizeOptions: number[] = [];

  @Output() pageChanged = new EventEmitter();

  pages: number[];

  @HostBinding('class.pagination') cssClass = true;

  onKeyPressPageNum(page: number, event: KeyboardEvent) {
    if (event.which === Keys.ENTER) {
      this.setPage(page, event);
    }
  }

  //Function to be called for each page click
  setPage(page: number, event?: Event): void {//MouseEvent): void { // GO TO Page also included now - IMP
    //console.log(this.perPage)
    if (event) {
      event.preventDefault();
    }

    if (event && event.target) {
      const target: any = event.target;
      target.blur();
    }
    if (page > 0 && page <= this.totalPages() && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChanged.emit({ currentPage: this.currentPage, perPage: this.perPage, perPageOrCurrPageChanged: true } as PageEvent);
    }
    //console.log(this.currentPage)
  }

  //https://stackoverflow.com/questions/48422270/how-to-select-all-anchor-tags-with-specific-text-content-with-javascript
  findElements(tag, text) {
    var elements = document.getElementsByTagName(tag);
    //var found = [];
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].innerText === text) {
        //found.push(elements[i]);
        elements[i].className += " active";//https://stackoverflow.com/questions/44165102/angular-toggle-active-class-on-only-button-the-current-clicked-button-not-usin
      }
    }

    //return found;
  }

  totalPages(): number {
    const totalPages = this.perPage < 1 ? 1 : Math.ceil(this.totalItems / this.perPage);
    return Math.max(totalPages || 0, 1);
  }

  getPages(): number[] {
    console.log
    const maxSize = 3;
    const pages: number[] = [];
    let startPage = 1;
    const totalPages = this.totalPages();
    let endPage = totalPages;

    if (maxSize < totalPages) {
      startPage = Math.max(this.currentPage - Math.floor(maxSize / 2), 1);
      endPage = startPage + maxSize - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - maxSize + 1;
      }
    }
    for (let num = startPage; num <= endPage; num++) {
      pages.push(num);
    }
    return pages;
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) { return `0 of ${length}`; }

    length = Math.max(length, 0);

    const startIndex = (page - 1) * pageSize;
    let newIndex = Math.min(parseInt(startIndex.toString()) + parseInt(pageSize.toString()), parseInt(length.toString()));//IMP = paseInt needed for addition of number type
    //console.log(newIndex)
    const endIndex = startIndex < length ?
      newIndex :
      parseInt(startIndex.toString()) + parseInt(pageSize.toString());
    //console.log(endIndex)
    return `${startIndex + 1} - ${endIndex} of ${length} results count`;
  }

  //onChangePageSize(pageSize: number) {
  //  this.perPage = pageSize;
  //  this.currentPage = 1;//start from the beginning but not from the page selected
  //  this.pageChanged.emit({ currentPage: this.currentPage, perPage: this.perPage } as PageEvent);
  //}

}
